module.exports = __webpack_public_path__ + "static/media/cookie5-angle.31e6ca18.png";